export const SblDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/sbldevice/reducer/SblDeviceOverviewReducer.js